module.exports = __webpack_public_path__ + "static/banner-part-1-7b8ffdb926a2a9a33d1a0772b4183902.svg";